import { render, staticRenderFns } from "./activitylist.vue?vue&type=template&id=46b603a7&scoped=true"
import script from "./activitylist.vue?vue&type=script&lang=js"
export * from "./activitylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b603a7",
  null
  
)

export default component.exports